<div class="dialog-splitter"></div>

<style>
  .dialog-splitter {
    height: 1px;
    background-color: #cccccc;
    width: 100%
  }
</style>